// Instance
import AuthAPI from '@/app/apis/auth/auth-api.js';

// Endpoints
import { AUTH, AUTH_ENDPOINTS } from '@/app/apis/auth/_connection/auth-connection-api.js';

class AuthLoginAPI extends AuthAPI {
    /**
     * @param {*} authDetails - Contains email and password
     */
    async putAuthLogin(authDetails) {
      return AUTH.post(AUTH_ENDPOINTS.POST_LOGIN, authDetails);
    }
}
  
export default new AuthLoginAPI();
  